import TableAttributeModel from "./TableAttributeModel";
import {ActionIcon, Box, Center, Divider, Group, rem, ScrollArea, Table} from "@mantine/core";
import {ApiResponseDataType, ApiResponseDataValueType} from "../common/utilities";
import {IconEdit, IconTrash} from "@tabler/icons-react";
import React from "react";
import TableCellComponent from "./TableCellComponent";
import './TableComponent.css';


function formatDisplayDate(dateString: string): string {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateString)) {
        return dateString;
    }
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
}
export default function TableComponent({tableAttributes, values, onRemove, onEdit, onOpenRelated,
editable,
deletable}: {
    tableAttributes: TableAttributeModel[],
    editable: Boolean,
    deletable: Boolean,
    values?: ApiResponseDataType[] | undefined,
    onRemove: (item: ApiResponseDataType) => void,
    onEdit: (item: ApiResponseDataType) => void,
    onOpenRelated: (attribute: TableAttributeModel, value: ApiResponseDataValueType) => void
}) {
    return (
        <Box style={{
            borderStyle: "solid",
            borderColor: "#00000020",
            borderWidth: "1px",
            borderRadius: "8px",
            // paddingTop: "8px"
        }}>
               <ScrollArea>
            <Table striped={true} highlightOnHover={true}
                   stickyHeader={true}
                   stickyHeaderOffset={60}
                   >
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th>#</Table.Th>
                        {tableAttributes.map((item, index) => {
                            return <Table.Th>{item.label}</Table.Th>
                        })}
                        <Table.Th></Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {values?.map((item, index) => {
                        return <Table.Tr key={index}>
                            <Table.Td>{index + 1}</Table.Td>
                            {tableAttributes.map((attribute) => {
                                let val = Array.isArray(item[attribute.name]) ? item[attribute.name]?.toString() as string : item[attribute.name] as string


                                if (attribute.fieldType === 'date' && val) {
                                    val = formatDisplayDate(val);
                                }
                                
                                return <TableCellComponent key={val}
                                                           data={val}
                                                           related={attribute.linkedTable !== undefined}
                                                           copy={attribute.showCopy}
                                                           onOpenRelated={(data) => onOpenRelated(attribute, data)}
                                />
                            })}
                            <Table.Td align="right">
                                <Group justify={'flex-end'}>
                                    <Group align={'center'} justify={'end'} bg={'#00000005'}
                                           style={{
                                               paddingLeft: 10,
                                               paddingRight: 10,
                                               paddingTop: 2,
                                               paddingBottom: 2,
                                               borderRadius: 10
                                           }}
                                           gap={'sm'}>
                                       {editable &&
                                        <ActionIcon variant={"subtle"} color={"blue"} onClick={() => onEdit(item)}>
                                            <IconEdit style={{width: rem(18), height: rem(18)}} stroke={1.5}/>
                                        </ActionIcon>}
                                        <Center><Divider orientation={'vertical'} h={10}/></Center>
                                       {deletable &&
                                        <ActionIcon variant={"subtle"} color={"red"} onClick={() => onRemove(item)}>
                                            <IconTrash style={{width: rem(18), height: rem(18)}} stroke={1.5}/>
                                        </ActionIcon>}
                                    </Group>
                                </Group>
                            </Table.Td>
                        </Table.Tr>
                    })}
                </Table.Tbody>
            </Table>
            </ScrollArea>
        </Box>
    )
}